import { render } from "./PartnersSlider.vue?vue&type=template&id=bbacd2a2"
import script from "./PartnersSlider.vue?vue&type=script&lang=js"
export * from "./PartnersSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__